import { render, staticRenderFns } from "./MarketingPos.vue?vue&type=template&id=242bd6b6&scoped=true"
import script from "./MarketingPos.vue?vue&type=script&lang=js"
export * from "./MarketingPos.vue?vue&type=script&lang=js"
import style0 from "./MarketingPos.vue?vue&type=style&index=0&id=242bd6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242bd6b6",
  null
  
)

export default component.exports